import { render, staticRenderFns } from "./MediaConsent.vue?vue&type=template&id=c860fbc2"
import script from "./MediaConsent.vue?vue&type=script&lang=js"
export * from "./MediaConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports